import { render, staticRenderFns } from "./marketBlacklistManageList.vue?vue&type=template&id=39337eb8&scoped=true"
import script from "./marketBlacklistManageList.vue?vue&type=script&lang=js"
export * from "./marketBlacklistManageList.vue?vue&type=script&lang=js"
import style0 from "./marketBlacklistManageList.vue?vue&type=style&index=0&id=39337eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39337eb8",
  null
  
)

export default component.exports